module.exports = __webpack_public_path__ + "static/media/cn.baedda5d.png";